import { LOCAL_STORAGE_SETTINGS_KEY } from '../constants';
var loadLocalStorageSettings = function () {
    var savedSettingsStr = localStorage.getItem(LOCAL_STORAGE_SETTINGS_KEY);
    if (savedSettingsStr) {
        try {
            return JSON.parse(savedSettingsStr);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
        }
    }
};
export default loadLocalStorageSettings;
